/**
 * ConfirmationStatus is an extension for YesNoInProgress enum.
 * It serves options for B/C/D Qualifications Responses.
 */
export enum ConfirmationStatus {
  Yes = 'yes',
  No = 'no',
  BasicNursing = 'basic_nursing',
  InProgress = 'in_progress',
  AcquiredAbroad = 'acquired_abroad',
}

export const CONFIRMATION_STATUS_TRANSLATIONS = {
  [ConfirmationStatus.Yes]: 'Ja',
  [ConfirmationStatus.No]: 'Nein',
  [ConfirmationStatus.BasicNursing]: 'Pflegebasiskurs',
  [ConfirmationStatus.InProgress]: 'Begonnen und noch nicht abgeschlossen',
  [ConfirmationStatus.AcquiredAbroad]: 'Im Ausland erworben',
};
